module.exports = __webpack_public_path__ + "static/media/top_arrow.407fe6be.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/forum/top_arrow.svg
// module id = ./src/assets/media/forum/top_arrow.svg
// module chunks = 16